import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, ModalData, ModalRef } from '@ui-lib/components';

@Component({
  selector: 'mon-role-action-confirmation-modal',
  templateUrl: './role-action-confirmation-modal.component.html',
  styleUrls: ['./role-action-confirmation-modal.component.scss'],
  imports: [ButtonComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleActionConfirmationModalComponent extends ModalData {
  private readonly modalRef = inject(ModalRef<boolean>);

  /**
   * Отменить
   */
  public cancel(): void {
    this.modalRef.close(false);
  }

  /**
   * Подтвердить
   */
  public confirm(): void {
    this.modalRef.close(true);
  }
}
